<div class="d-flex flex-column min-vh-100">
  <app-header></app-header>

  <main [@siRouterFadeAnimation]="getRouteAnimation(route)" class="flex-fill">
    <router-outlet #route="outlet"></router-outlet>
  </main>

  <footer class="si-footer si-footer-legal-only mt-auto">
    <div class="container">
      <si-copyright></si-copyright>
    </div>
  </footer>
  <!-- Single MSAL redirect handler (do not bootstrap separately) -->
  <!-- Handles processing of auth code response after first redirect -->
  <msal-redirect></msal-redirect>
</div>